<template>
  <div >
    <v-tooltip bottom>
    <!-- <div slot="activator"> -->
      <template v-slot:activator="{on, attrs}">
      <div class="gaugeblock-text" style="text-align: center;">
        {{getGaugeTitle(prop.item.sensors[prop.index])}}
      </div>
      <v-progress-circular class="gaugeblock"  
      v-bind="attrs"
      v-on="on" 
        style="margin: 1px; margin-right: 5px;"  
        size="48" 
        :color="getGaugeColor(prop.g, prop.item.sensors[prop.index])" 
        :rotate="120" 
        :value="getGaugePercent(prop.g, prop.item.sensors[prop.index])"
      >
        <font size="-2">{{Number(prop.g).toFixed(1)}}</font>
      </v-progress-circular>
    <!-- </div> -->
    </template>
    {{getToolTip(prop.item.sensors[prop.index])}}
    </v-tooltip>
  </div>
  
  
</template>

<script type="text/babel">
  import { sync } from 'vuex-pathify'
  import axiosInstances from '@/../../coreui/server/axiosInstances'
  export default {
    props: {
      prop: {
        type: Object,
        required: true
      }
    },
    data:() => ({
      dictionary: []
    }),
    computed: {
      // dictionary: sync('dictionary')
    },
    methods: {
      getGaugeColor (val, item) {
        if (this.dictionary.length == 0) return 'gray'
        let index = this.dictionary.findIndex(p => p.code == item)
        if (val > Number(this.dictionary[index].error)) return 'red'
        if (val > Number(this.dictionary[index].warn)) return 'orange'
        if (val > Number(this.dictionary[index].med)) return 'yellow'
        if (val > Number(this.dictionary[index].low)) return 'green'
        else return 'blue'
      },
      getGaugePercent (val, item) {
        if (this.dictionary.length == 0) return ''
        let index = this.dictionary.findIndex(p => p.code == item)
        return val * 100 / Number(this.dictionary[index].max)
      },
      getGaugeTitle(item) {
        if (this.dictionary.length == 0) return ''
        let index = this.dictionary.findIndex(p => p.code == item)
        let sc = this.dictionary[index].short 
        if (sc) return sc
        return this.dictionary[index].label.substring(0,5)
      },
      getToolTip(item) {
        if (this.dictionary.length == 0) return ''
        let index = this.dictionary.findIndex(p => p.code == item)
        return this.dictionary[index].label
      }
    },
    async mounted () {
      var res = await axiosInstances.loginServer.get('dt/v1/dictionary')
      this.dictionary = res.data
    }
  }
</script>

<style scoped>
.gaugerow {
text-align: center; 
border: 1px solid grey;
padding: 1px;
/* border-right: 1px solid gray; */
/* border-bottom: 1px solid gray; */
}
/* .gaugeblock {
  display: block;
  width: 48px;
} */
/* .gaugeblock-text {
  display: inline-block;
  width: 48px;
} */
</style>